//Name: Kid Clothing
//CODE: KIDC
//Age: Child
//Gender: Both
const kidClothingOptions = [
  { id: '135', values: [
    {region: "AU", name: "000"},
    {region: "NZ", name: "000"},
    {region: "US", name: "3-9 m"},
    {region: "UK", name: "3-9 m"},
    {region: "EU", name: "6-74 cm"}
  ]},
  { id: '134', values: [
    {region: "AU", name: "00"},
    {region: "NZ", name: "00"},
    {region: "US", name: "9-12 m"},
    {region: "UK", name: "9-12 m"},
    {region: "EU", name: "74-80 cm"}
  ]},
  { id: '133', values: [
    {region: "AU", name: "0"},
    {region: "NZ", name: "0"},
    {region: "US", name: "12 m"},
    {region: "UK", name: "12 m"},
    {region: "EU", name: "80 cm"}
  ]},
  { id: '138', values: [
    {region: "AU", name: "1"},
    {region: "NZ", name: "1"},
    {region: "US", name: "12-18 m"},
    {region: "UK", name: "12-18 m"},
    {region: "EU", name: "80-86 cm"}
  ]},
  { id: '110', values: [
    {region: "AU", name: "2"},
    {region: "NZ", name: "2"},
    {region: "US", name: "2 T"},
    {region: "UK", name: "18-24 m"},
    {region: "EU", name: "86-92 cm"}
  ]},
  { id: '139', values: [
    {region: "AU", name: "3"},
    {region: "NZ", name: "3"},
    {region: "US", name: "3 T"},
    {region: "UK", name: "2-3"},
    {region: "EU", name: "92-98 cm"}
  ]},
  { id: '111', values: [
    {region: "AU", name: "4"},
    {region: "NZ", name: "4"},
    {region: "US", name: "4 T"},
    {region: "UK", name: "3-4"},
    {region: "EU", name: "98-104 cm"}
  ]},
  { id: '140', values: [
    {region: "AU", name: "5"},
    {region: "NZ", name: "5"},
    {region: "US", name: "5"},
    {region: "UK", name: "4-5"},
    {region: "EU", name: "104-110 cm"}
  ]},
  { id: '112', values: [
    {region: "AU", name: "6"},
    {region: "NZ", name: "6"},
    {region: "US", name: "6"},
    {region: "UK", name: "5-6"},
    {region: "EU", name: "110-116 cm"}
  ]},
  { id: '141', values: [
    {region: "AU", name: "7"},
    {region: "NZ", name: "7"},
    {region: "US", name: "7"},
    {region: "UK", name: "6-7"},
    {region: "EU", name: "116-122 cm"}
  ]},
  { id: '113', values: [
    {region: "AU", name: "8"},
    {region: "NZ", name: "8"},
    {region: "US", name: "8"},
    {region: "UK", name: "7-8"},
    {region: "EU", name: "122-128 cm"}
  ]},
  { id: '142', values: [
    {region: "AU", name: "9"},
    {region: "NZ", name: "9"},
    {region: "US", name: "9"},
    {region: "UK", name: "8-9"},
    {region: "EU", name: "128-134 cm"}
  ]},
  { id: '114', values: [
    {region: "AU", name: "10"},
    {region: "NZ", name: "10"},
    {region: "US", name: "10"},
    {region: "UK", name: "9-10"},
    {region: "EU", name: "134-140 cm"}
  ]},
  { id: '143', values: [
    {region: "AU", name: "11"},
    {region: "NZ", name: "11"},
    {region: "US", name: "11"},
    {region: "UK", name: "10-11"},
    {region: "EU", name: "140-146 cm"}
  ]},
  { id: '115', values: [
    {region: "AU", name: "12"},
    {region: "NZ", name: "12"},
    {region: "US", name: "12"},
    {region: "UK", name: "11-12"},
    {region: "EU", name: "146-152 cm"}
  ]},
  { id: '144', values: [
    {region: "AU", name: "13"},
    {region: "NZ", name: "13"},
    {region: "US", name: "13"},
    {region: "UK", name: "12-13"},
    {region: "EU", name: "152-158 cm"}
  ]},
  { id: '136', values: [
    {region: "AU", name: "14"},
    {region: "NZ", name: "14"},
    {region: "US", name: "14"},
    {region: "UK", name: "13-14"},
    {region: "EU", name: "158-164 cm"}
  ]},
  { id: '145', values: [
    {region: "AU", name: "15"},
    {region: "NZ", name: "15"},
    {region: "US", name: "15"},
    {region: "UK", name: "14-15"},
    {region: "EU", name: "158-164 cm"}
  ]},
  { id: '137', values: [
    {region: "AU", name: "16"},
    {region: "NZ", name: "16"},
    {region: "US", name: "16"},
    {region: "UK", name: "16"},
    {region: "EU", name: "158-164 cm"}
  ]}
];

export default kidClothingOptions;



// WEBPACK FOOTER //
// ./src/data/kid-clothing-options.js